import React, { useEffect, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { GET_FAVORITES, ADD_FAVORITE, DELETE_FAVORITE } from '../graphql/favorites';
import { useAuthData } from "../context/AuthProvider";

const useFavorites = () => {
    const { auth } = useAuthData();

    const { data, loading, refetch } = useQuery(GET_FAVORITES, {
        skip: !auth, // Alleen uitvoeren als ingelogd
    });

    const [addFavorite] = useMutation(ADD_FAVORITE);
    const [deleteFavorite] = useMutation(DELETE_FAVORITE);

    const [favorites, setFavorites] = useState([]);

    useEffect(() => {
        if (!loading && data && data.userFavorites) {
            setFavorites(data.userFavorites);
        } else {
            setFavorites([]);
        }
    }, [data, loading]);

    const toggleFavorite = async (photoId, imageUrl) => {
        if (!auth) {
            alert("Log in om favorieten te beheren.");
            return false;
        }

        const existingFavorite = favorites.find(fav => fav.photo_id === photoId);

        if (existingFavorite) {
            await deleteFavorite({ variables: { id: existingFavorite.id } });
        } else {
            await addFavorite({
                variables: {
                    input: { photo_id: photoId, image_url: imageUrl }
                }
            });
        }

        await refetch();
        window.dispatchEvent(new Event('favoritesUpdated'));
        return true;
    };

    return { favorites, toggleFavorite, refetch };
};

export default useFavorites;
